/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
   
==========================================================================================*/


const mutations = {


  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu

  toggleIsVerticalNavMenuActive(value) {
    this.isVerticalNavMenuActive = value
  },
  updateVerticalNavMenuItemsMin(val) {
    this.verticalNavMenuItemsMin = val
  },


  // ////////////////////////////////////////////
  // UI
  // ////////////////////////////////////////////

  toggleContentOverlay(val) { this.bodyOverlay       = val },
  updateWindowWidth(width)  { this.windowWidth       = width },
  updateWindowScrollY(val) { this.scrollY = val },


  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  // Updates user info in state and localstorage
  updateUserInfo(payload) {

    // Get Data localStorage
    let userInfo = JSON.parse(localStorage.getItem("userInfo")) || this.AppActiveUser

    for (const property of Object.keys(payload)) {

      if (payload[property] != null) {
        // If some of user property is null - user default property defined in this.AppActiveUser
        this.AppActiveUser[property] = payload[property]

        // Update key in localStorage
        userInfo[property] = payload[property]
      }
    }
    // Store data in localStorage
    localStorage.setItem("userInfo", JSON.stringify(userInfo))
  },
}

export default mutations

